import AES from 'crypto-js/aes';

export default {
	methods: {
		encryptIndex(index) {
			return AES.encrypt(index, this.aesSecret).toString()
		},
	}
}